import { useEffect, useState } from "react";
import { selectListItems } from "../../../../../redux/library/selector";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table-manager/v1.1/table";
import { selectEventTicketsListItems } from "../../../../../redux/event/event-tickets/selector";
import { eventTickets } from "../../../../../redux/event/event-tickets/action";


const AgencyEventTickets = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [pageData, setPageData] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const libraryData = useSelector(selectListItems);
    const eventTicketsItemsData = useSelector(selectEventTicketsListItems);
    const [columnDefs, setColumnDefs] = useState({});

    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(params.node.id, 10) + 1;
                },
            },
            { field: 'Name', headerName: 'Name',searchField: 'Name', sortable: true, filter: true, filterType: 'text' },
            { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
            { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true },
        ]);
    };

    const fetchEventTicketsList = () => {
        dispatch(eventTickets.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/event/tickets/list`,
            entity: 'eventTickets',
            jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc"
            }
        }));
    };

    useEffect(() => {
        createColumnDefs();
        fetchEventTicketsList();
    }, [pageData, pageSize]);


    const handleAdd = () => {
        navigate(`${0}`);
    };

    

    const handleDelete = (data: any) => {
        dispatch(eventTickets.delete({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/event/tickets/delete`,
            entity: 'eventTickets',
            jsonData: {
                Records: [
                    {
                        Id: data?.Id
                    }
                ]
            }
        })).then(() => {
            fetchEventTicketsList();
        });
    };

    const handleEdit = (data: any) => {
        navigate(`${data?.Id}`)
      }
      const handleReloadData = () => {
        fetchEventTicketsList()
      }
      const additionButtons: any = [
        {
          svg:
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
              <title>Add Event Tickets</title>
              <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
            </svg>,
          callback: () => handleAdd(),
        },
        
        {
          svg:
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
              <title>Reload this table</title>
              <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>,
          callback: () => handleReloadData(),
        },
      ];
    
      const handleSearch = (data: any) => {
        let searchCriteria = {};
        if (data?.column) {
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "Name",
            FieldText: "Name",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } 

        dispatch(eventTickets.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/event/tickets/list`,
            entity: 'eventTickets',
            jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc",
                "Searches": searchCriteria,
              }
        }));
    };

    

    return (
        <>
            {eventTicketsItemsData?.isLoading ? 
                <PageLoader /> :
                <Table 
                checkboxConfig={{
                    allowMultiSelect: true,
                    defaultSelectedIds: [],
                    isDisabled: false,
                    keyColumn: 'Id',
                  }}
                    columnData={columnDefs} 
                    rowData={eventTicketsItemsData?.result?.items} 
                    setPageData={setPageData}
                    setPageSize={setPageSize}
                    enableFilter={true}
                     onSearch={handleSearch} 
                    paginationData={eventTicketsItemsData?.result?.pagination}
                    additionButtons={additionButtons} 
                    onEdit={handleEdit} 
                    onDelete={handleDelete}
                    headingName="Event Tickets" 
                />
            }
        </>
    );
};

export default AgencyEventTickets;
